<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-2" lang="en-GB"><a id="_idTextAnchor003"></a>Dark prison</h1>
<p class="Verse-first" lang="en-GB">I am in pain inside this dark prison</p>
<p class="Verse-main" lang="en-GB">I am thirsty, please give me peace</p>
<p class="Verse-main" lang="en-GB">I have no peace, no hope for tomorrow</p>
<p class="Verse-main" lang="en-GB">Please set me free, I am desperate</p>
<p class="Verse-main" lang="en-GB">I am in deep darkness, I suffer much</p>
<p class="Verse-main" lang="en-GB">I thought I knew it, I thought I have seen it</p>
<p class="Verse-main" lang="en-GB">I want to die but there is no death </p>
<p class="Verse-main" lang="en-GB">My soul is tormented day and night without sense of time</p>
<p class="Verse-main" lang="en-GB">My soul is troubled in much distress</p>
<p class="Verse-main" lang="en-GB">Inside here only memories</p>
<p class="Verse-main" lang="en-GB">Wiser I should be, foolish I was, now is just too late</p>
<p class="Verse-main" lang="en-GB">In this dark prison of fire there is no way out</p>
<p class="Verse-main" lang="en-GB">In this place of sorrow only pain and distress</p>
<p class="Verse-main" lang="en-GB">As a loud music I hear the cries of my soul</p>
<p class="Verse-main" lang="en-GB">I hear the cries of the doomed the pains of the dead</p>
<p class="Verse-main" lang="en-GB">I am in here forever </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398406179_EPUB4.vue?5da49ee8